export default "__VITE_ASSET__BVWqdGR6__"